import { createSlice } from '@reduxjs/toolkit';
import { PAGE_TYPES } from '@utils/pageType';
import { v4 as uuid } from 'uuid';
import appTypes, { APP_CONTEXT } from './types';
export const DEFAULT_APP_ROUTE = 'lusha-contacts';
const initialState = {
    url: '',
    previousUrl: '',
    isParserExistsForPage: false,
    isContentScriptReady: false,
    contentSessionId: 0,
    sessionId: uuid(),
    isRefreshingSearch: false,
    isSearchLimitReached: false,
    appContext: APP_CONTEXT.PROSPECT,
    pageType: PAGE_TYPES.UNKNOWN,
};
const slice = createSlice({
    name: 'APP',
    initialState,
    extraReducers(builder) {
        builder.addCase(appTypes.RESET, () => initialState);
    },
    reducers: {
        setApp(state, { payload }) {
            state.app = payload;
        },
        setUrl(state, { payload: urlNext }) {
            // Written unconditionally: the core plugin re-sends `PAGE` with an unchanged url, and a
            // conditional write would make such a repeat look like a page change to later consumers.
            state.previousUrl = state.url;
            if (state.url !== urlNext) {
                state.parserResult = undefined;
                state.isContentScriptReady = false;
                state.url = urlNext;
                state.appDataState = undefined;
            }
        },
        setIsContentScriptReady(state) {
            state.contentSessionId += 1;
            state.isContentScriptReady = true;
        },
        setPageNotSupported(state) {
            state.parserResult = undefined;
            state.appRoute = DEFAULT_APP_ROUTE;
        },
        setParserResult(state, { payload }) {
            const type = payload.type || payload.parserCategory;
            switch (type) {
                case 'profile':
                    state.appRoute = DEFAULT_APP_ROUTE;
                    break;
                case 'company':
                    state.appRoute = 'lusha-scout';
                    break;
                case 'bulk_profile':
                    state.appRoute = 'lusha-bulk';
                    break;
                default:
                    // redirect to contact, it supposed to show skeleton or nav
                    state.appRoute = DEFAULT_APP_ROUTE;
                    break;
            }
            state.parserResult = payload;
        },
        setAppDataState(state, { payload }) {
            state.appDataState = payload;
        },
        setIsRefreshingSearch(state, { payload }) {
            state.isRefreshingSearch = payload;
        },
        setIsSearchLimitReached(state, { payload }) {
            state.isSearchLimitReached = payload;
        },
        setAppContext(state, { payload }) {
            state.appContext = payload;
        },
        setPageType(state, { payload }) {
            state.pageType = payload;
        },
        setIsParserExistsForPage(state, { payload }) {
            state.isParserExistsForPage = payload;
        },
    },
});
export const { reducer, actions } = slice;
export default reducer;
